(() => {
  const gallery = document.querySelector('[data-becoming-gallery]');
  if (gallery) {
    const media = gallery.querySelector('.becoming-product__media');
    const thumbsContainer = gallery.querySelector('.becoming-product__thumbs');
    const slides = Array.from(gallery.querySelectorAll('[data-becoming-slide]'));
    const thumbs = Array.from(gallery.querySelectorAll('[data-becoming-thumb]'));
    if (media && thumbsContainer && slides.length > 1 && thumbs.length > 0) {
      const mobileMediaQuery = window.matchMedia('(max-width: 749px)');
      const reducedMotionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
      let activeIndex = Math.max(0, slides.findIndex((slide) => slide.classList.contains('is-active')));
      let scrollFrame = 0;
      let resizeFrame = 0;

      const setActive = (index, force = false) => {
        const nextIndex = Math.max(0, Math.min(index, slides.length - 1));
        if (nextIndex === activeIndex && !force) return;
        activeIndex = nextIndex;
        slides.forEach((slide, slideIndex) => {
          slide.classList.toggle('is-active', slideIndex === nextIndex);
        });
        thumbs.forEach((thumb, thumbIndex) => {
          const active = thumbIndex === nextIndex;
          thumb.classList.toggle('is-active', active);
          thumb.setAttribute('aria-pressed', String(active));
          if (active && mobileMediaQuery.matches) {
            const maxScroll = Math.max(0, thumbsContainer.scrollWidth - thumbsContainer.clientWidth);
            const centeredScroll = thumb.offsetLeft + (thumb.offsetWidth / 2) - (thumbsContainer.clientWidth / 2);
            thumbsContainer.scrollTo({
              left: Math.max(0, Math.min(centeredScroll, maxScroll)),
              behavior: reducedMotionQuery.matches ? 'auto' : 'smooth'
            });
          }
        });
      };

      const scrollToSlide = (index) => {
        setActive(index);
        media.scrollTo({
          left: index * media.clientWidth,
          behavior: reducedMotionQuery.matches ? 'auto' : 'smooth'
        });
      };

      const syncFromScroll = () => {
        scrollFrame = 0;
        if (!mobileMediaQuery.matches || media.clientWidth === 0) return;
        setActive(Math.round(media.scrollLeft / media.clientWidth));
      };

      thumbs.forEach((thumb) => {
        thumb.addEventListener('click', () => {
          const index = Number(thumb.dataset.becomingThumb);
          if (mobileMediaQuery.matches) {
            scrollToSlide(index);
          } else {
            setActive(index);
          }
        });
      });

      media.addEventListener('scroll', () => {
        if (!mobileMediaQuery.matches || scrollFrame) return;
        scrollFrame = window.requestAnimationFrame(syncFromScroll);
      }, { passive: true });

      const handleViewportChange = () => {
        if (scrollFrame) {
          window.cancelAnimationFrame(scrollFrame);
          scrollFrame = 0;
        }
        if (mobileMediaQuery.matches) {
          media.scrollTo({ left: activeIndex * media.clientWidth, behavior: 'auto' });
        }
        setActive(activeIndex, true);
      };

      if (mobileMediaQuery.addEventListener) {
        mobileMediaQuery.addEventListener('change', handleViewportChange);
      } else {
        mobileMediaQuery.addListener(handleViewportChange);
      }
      window.addEventListener('resize', () => {
        if (resizeFrame) window.cancelAnimationFrame(resizeFrame);
        resizeFrame = window.requestAnimationFrame(() => {
          resizeFrame = 0;
          handleViewportChange();
        });
      }, { passive: true });
      handleViewportChange();
    }
  }

  document.querySelectorAll('[data-becoming-initials]').forEach((input) => {
    const digits = input.form?.querySelector('[data-becoming-digits]');
    const properties = Array.from(input.form?.querySelectorAll('[data-becoming-personalization-property]') || []);
    const syncPersonalization = () => {
      input.value = input.value.replace(/[^a-z]/gi, '').slice(0, 6).toUpperCase();
      if (digits) digits.value = digits.value.replace(/[^0-9]/g, '').slice(0, 4);
      const hasPersonalization = input.value.length > 0 || (digits?.value.length || 0) > 0;
      properties.forEach((property) => {
        property.disabled = !hasPersonalization;
      });
    };
    input.addEventListener('input', syncPersonalization);
    digits?.addEventListener('input', syncPersonalization);
    syncPersonalization();
  });

  document.querySelectorAll('[data-becoming-sort]').forEach((select) => {
    select.addEventListener('change', () => select.form?.submit());
  });

  const archive = document.querySelector('[data-becoming-archive]');
  if (archive) {
    const filters = Array.from(archive.querySelectorAll('[data-archive-filter]'));
    const works = Array.from(archive.querySelectorAll('.becoming-archive__work'));
    const empty = archive.querySelector('[data-archive-empty]');
    filters.forEach((button) => {
      button.addEventListener('click', () => {
        const filter = button.dataset.archiveFilter;
        let visible = 0;
        filters.forEach((item) => {
          const active = item === button;
          item.classList.toggle('is-active', active);
          item.setAttribute('aria-pressed', String(active));
        });
        works.forEach((work) => {
          const show = filter === 'all' || work.dataset.archiveType === filter || work.dataset.archiveStatus === filter;
          work.hidden = !show;
          if (show) visible += 1;
        });
        if (empty) empty.hidden = visible !== 0;
      });
    });
  }
})();
